import BaseApi from '../base';

class QuestionnaireApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getQuestionnaires(token) {
    return this.makeRequest(this.METHOD_GET, 'questionnaires', token);
  }

  /**
   * @param {string} token
   * @param {string} questionnaireId
   * @returns {Promise<*>}
   */
  async getAnswers(token, questionnaireId) {
    return this.makeRequest(
      this.METHOD_GET,
      `questionnaires/${questionnaireId}/answers`,
      token
    );
  }

  /**
   * @param {string} token
   * @param {string} questionnaireId
   * @param answers
   * @returns {Promise<void>}
   */
  async submitAnswers(token, questionnaireId, answers) {
    return this.makeRequest(
      this.METHOD_POST,
      `questionnaires/${questionnaireId}/answers`,
      token,
      answers
    );
  }
}

export default QuestionnaireApi;
